'use strict';

// Public pages app module - minimal version without authenticated features
// This file replaces app.js for public pages (surveys, embeddable content)

angular
    .module('App.v1', [
        'App.v1.Controllers.Public',
        'App.v1.Services',
        'App.v1.Directives',
        'App.v1.Filters',
        'ngResource'])

    .config(['$locationProvider',
        function ($locationProvider) {
            $locationProvider.html5Mode(true).hashPrefix('!');
        }]);

// Register Services module. Will add specific services to the module via files in ./Services/*.js files
angular.module('App.v1.Services', ['ngResource']);

//Register Public Controllers module that are very slim and don't need the full services
angular.module('App.v1.Controllers.Public', ['App.v1.Services']);

//// Register Directives module. Will add specific services to the module via files in ./Directives/*.js files
angular.module('App.v1.Directives', ['ngMessages']);

angular.module('App.v1.Filters', []);
